import { ComponentProps, FC } from "react";

import Avatar from "@src/lib/ui/Avatar";

import { getChatOtherMembers } from "./utils";

type Person = ComponentProps<typeof Avatar>["person"];

type Props = {
  members: Person[];
  viewerId: number | undefined;
  size: number;
};

const MOBILE_BASE_SIZE = 30;

const DirectMessageAvatar: FC<Props> = ({ members, viewerId, size }) => {
  const others = getChatOtherMembers(members, viewerId);

  if (others.length > 1) {
    const radius = Math.round((8 * size) / MOBILE_BASE_SIZE);
    const fontSize = Math.max(10, Math.round((14 * size) / MOBILE_BASE_SIZE));
    return (
      <div
        className="flex shrink-0 items-center justify-center bg-gray-1 font-semibold text-gray-9"
        style={{ width: size, height: size, borderRadius: radius, fontSize }}
      >
        {others.length}
      </div>
    );
  }

  const person = others[0] ?? members[0];
  return person ? <Avatar person={person} size={size} /> : null;
};

export default DirectMessageAvatar;
